import template from './loader.html';
import './loader.styl';

const loaderComponent = {
  template,
  bindings: {
    data: '='
  }
};

export default loaderComponent;



/** WEBPACK FOOTER **
 ** ./frontend/components/utility/loader/loader.component.js
 **/